import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { AdminAuthProvider } from './lib/auth-context';
import { applyAdminFavicon } from './lib/favicon';
import { router } from './router';
import './index.css';

applyAdminFavicon();

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

// 숫자 입력에서 휠 스크롤·키보드 ↑/↓로 값이 증감하는 브라우저 기본 동작 차단
const isFocusedNumberInput = (t: EventTarget | null): t is HTMLInputElement =>
  t instanceof HTMLInputElement && t.type === 'number' && document.activeElement === t;

document.addEventListener(
  'wheel',
  (e) => {
    if (isFocusedNumberInput(e.target)) e.preventDefault();
  },
  { passive: false },
);
document.addEventListener('keydown', (e) => {
  if ((e.key === 'ArrowUp' || e.key === 'ArrowDown') && isFocusedNumberInput(e.target)) {
    e.preventDefault();
  }
});

const root = document.getElementById('root');
if (!root) throw new Error('root element not found');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AdminAuthProvider>
        <RouterProvider router={router} />
      </AdminAuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
